import { render, staticRenderFns } from "./CreateWeight.vue?vue&type=template&id=1472a1b6&scoped=true&"
import script from "./CreateWeight.vue?vue&type=script&lang=js&"
export * from "./CreateWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1472a1b6",
  null
  
)

export default component.exports